import { Stack } from "@fluentui/react";
import { useEffect, useRef } from "react";
import { MyTooltip } from "../../../common/views/MyTooltip";
import { FileType } from "../../../pictures/models/PictureModel";
import { PictureUtils } from "../../../pictures/views/PictureUtilities";
import { ProductKeyModel } from "../../models/ProductModel";
import { LinePickerModel, SizePickerModel, CodePickerModel } from "../../models/ProductPickerModels";
import { useProductPickerVM } from "../../viewmodels/ProductPickerVM";

export type ProductPickerProps = {
    product: ProductKeyModel;
    onChange: (key: ProductKeyModel) => void;
}

export default function ProductPickerView({ product, onChange }: ProductPickerProps) {
    const hasLoaded = useRef(false);
    const vm = useProductPickerVM(product, onChange);

    useEffect(() => {
        if (hasLoaded.current) return;

        hasLoaded.current = true;

        vm.getPicker();
    }, [vm]);

    const onRenderLineItem = (line: LinePickerModel, index: number) => {
        let isSelected = line.id === vm.selectedLine.id;

        return <div key={"color-" + index} className={"product-picker-wrapper picture-color-group-wrapper"}>
            <div className="picture-color-group-item" style={{ position: "relative" }}
                onClick={() => vm.onLineClick(line)}>
                <MyTooltip
                    element={PictureUtils.getMiniPicture(FileType.image, line.imageUrl, "", () => { })}
                    text={line.name}
                />
            </div>

            {isSelected && <div className="pt-5">
                <div className="color-selected"></div>
            </div>}
        </div>;
    }

    const onRenderSizeItem = (size: SizePickerModel, index: number) => {
        const wrapperClass = "product-picker-wrapper textbox-group-wrapper textbox-group-size-wrapper";
        let cssClass = size.name === vm.selectedSize.name ? "size-selected" : "";

        return <div key={"size-" + index} style={{ position: "relative" }}>
            <span className={wrapperClass + " " + cssClass}
                onClick={() => vm.onSizeClick(size)}>{size.name}</span>
        </div>;
    }

    const onRenderCodeItem = (code: CodePickerModel, index: number) => {
        const wrapperClass = "product-picker-wrapper textbox-group-wrapper textbox-group-others-wrapper";
        let cssClass = code.name === vm.selectedCode.name ? "others-selected" : "";

        return <div key={"code-" + index} style={{ position: "relative" }}>
            <span className={wrapperClass + " " + cssClass}
                onClick={() => vm.onCodeClick(code)}>{code.name}</span>
        </div>;
    }

    return <div>
        {vm.shouldShow(vm.pickers) && <>
            <div key={vm.lineListHash} className="pb-10" style={{ display: "flex" }}>
                <Stack horizontal className="inlineBlock">
                    {vm.pickers.map(onRenderLineItem)}
                </Stack>
            </div>
        </>}

        {vm.selectedLine && vm.shouldShow(vm.selectedLine.sizes) && <>
            <div key={vm.sizeListHash} className="pb-10" style={{ display: "flex" }}>
                <Stack horizontal className="inlineBlock" style={{ textAlign: "left" }}>
                    {vm.selectedLine.sizes.map(onRenderSizeItem)}
                </Stack>
            </div>
        </>}

        {vm.selectedSize && vm.shouldShow(vm.selectedSize.codes) && <>
            <div key={vm.codeListHash} className="pb-10" style={{ display: "flex" }}>
                <Stack horizontal className="inlineBlock" style={{ textAlign: "left" }}>
                    {vm.selectedSize.codes.map(onRenderCodeItem)}
                </Stack>
            </div>
        </>}
    </div>;
}